window.onscroll = () => {
    if (window.scrollY > 100) {
        document.querySelector('.header')?.classList.add('menu-hover')
    } else {
        document.querySelector('.header')?.classList.remove('menu-hover')
    }
}
